import * as tslib_1 from "tslib";
import { encode } from '../jsonEncode';
import { BaseApiUrl, LoginApiUrl, UIClientTypes, } from '@tradingblock/types';
import { LogoutTokenUrl } from '../constants';
import { verify } from '../utilities/JwtUtilities';
import { checkToken } from './checkToken';
function isString(x) {
    return typeof x === 'string';
}
export function TryLogin(values, options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const host = options.host || '';
        const loginUrl = host + (options.subdirectory ? options.subdirectory : '') + LoginApiUrl(options.subroot);
        const headers = { 'Content-Type': 'application/json' };
        return yield fetch(loginUrl, {
            method: 'POST',
            body: JSON.stringify({ encoded: encode(values) }),
            headers,
        })
            .then(res => res.json())
            .then(json => json);
    });
}
const httpOptions = {
    headers: { Accept: 'application/json' },
};
export const auth = (api) => {
    return {
        logout: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.authenticated().post(LogoutTokenUrl, {}, httpOptions);
        }),
        checkToken: checkToken(api),
    };
};
const tryVerify = (publicKey, token) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    try {
        var decoded = yield verify(publicKey, token, {
            clientType: [UIClientTypes.dashboard, UIClientTypes.application],
            algorithms: ['RS256'],
            ignoreExpiration: false,
        });
        if (!decoded || isString(decoded)) {
            console.warn('jwt response was invalid, an object was expected', decoded);
            return null;
        }
        else {
            const jwtValues = decoded;
            return { value: token, decoded: jwtValues };
        }
    }
    catch (err) {
        console.warn('token verification failed:', err);
        return null;
    }
});
export const verifyToken = (id_token, uiApi) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    const pubKey = yield fetch(`${BaseApiUrl}/publickey`).then(res => res.json());
    return yield tryVerify(pubKey.key, id_token);
});
//# sourceMappingURL=auth.js.map